import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { Distribution } from '@/@types/distribution'

interface MockGetDistributionsPathParams {
  alphaId: string
}

export const mockGetDistributions = http.get<MockGetDistributionsPathParams>(
  '/my-business/api/agency/v1/*/:alphaId/distributions',
  () => {
    const distributions: Distribution[] = Array.from({ length: 2 }).map(
      (_, i) => ({
        active: faker.datatype.boolean({ probability: 0.9 }),
        alphaId: i === 0 ? null : faker.string.uuid(),
        defaultEnabled: faker.datatype.boolean({ probability: 0.9 }),
        distChannelId: faker.number.int({ min: 1000, max: 10000 }),
        distChannelName: i === 1 ? 'Expedia' : 'Trend',
      }),
    )

    return HttpResponse.json({ data: distributions })
  },
)
